import type { Route } from '@application/types';
import type { CustomIconProps } from '@presentation/components/CustomIcon/types';

export type Images = {
  welcomeImage: string;
  preparationImage: string;
  educationImage: string;
  healthImage: string;
  groomingImage: string;
};

interface Cta {
  text: string;
  link: Route;
}

export interface Content {
  id: string;
  title?: string;
  content: string;
  cta?: Cta;
}

export interface Section {
  id: string;
  title: string;
  icon: CustomIconProps['name'];
  image: string;
  content: Content[];
}
